import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Loaders } from 'shared';

const useStyles = makeStyles(() => ({
  wrapper: {
    color: '#C4C4C4',
    fontSize: '18px',
    textAlign: 'center',
    padding: '8px 0',
    cursor: 'default',
  },
}));

const LoadingMessage = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Loaders.ContentLoader thickness={2} size={30} height={30} />
    </div>
  );
};

export default LoadingMessage;
